import Event from '../../core/Event';

export default class UserOrdersRequested extends Event {
    public static type = 'UserOrdersRequested';

    constructor() {
        super(UserOrdersRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/UserOrdersRequested.ts